export const FEATURE_FLAGS = {
  FEATURE_NEW_MC_CS_AGENT_CHAT: "FEATURE_NEW_MC_CS_AGENT_CHAT",
  FEATURE_QA_WIDGET: "FEATURE_QA_WIDGET",
  FEATURE_FACE_BLUR: "FEATURE_FACE_BLUR",
  FEATURE_AI_CHAT_MESSAGES: "FEATURE_AI_CHAT_MESSAGES",
  FEATURE_IS_VIDEO_UPLOAD_ENABLED_MC: "FEATURE_IS_VIDEO_UPLOAD_ENABLED_MC",
  FEATURE_IS_AUDIO_UPLOAD_ENABLED_MC: "FEATURE_IS_AUDIO_UPLOAD_ENABLED_MC",
  FEATURE_IS_ESTIMATED_EARNINGS_ENABLED: "FEATURE_IS_ESTIMATED_EARNINGS_ENABLED",
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;